<template>
    <BaseCard title="تنظیمات" cardClasses="mb-2" bodyClasses="p-0">
      <template v-slot:header>
        <div class="w-100 d-flex flex-row justify-content-between">
          <div>تنظیمات</div>
          <v-btn fab dark small color="primary">
            <v-icon large @click="showSetting = !showSetting">
              {{ showSetting ? "mdi-chevron-up" : "mdi-chevron-down" }}
            </v-icon>
          </v-btn>
        </div>
      </template>
      <template>
        <Transition name="slide-up">
          <v-container v-if="showSetting">
            <v-row>
              
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="filter.question"
                  outlined
                  label="سوال"
                  dense
                />
              </v-col>
             
              <v-col cols="12" md="6">
                <v-autocomplete
              required
                :rules="[
                  v => !!v || 'این فیلد الزامی است'
                ]"
                outlined
                dense
                chips
                small-chips
                :disabled="categoriesItems.disabled"
                clearable
                label="دسته بندی "
                :items="categoriesItems"
                v-model="filter.faqCategoryId"
              ></v-autocomplete>
              </v-col>
  
              
              <v-col cols="12">
                <v-btn
                  color="blue"
                  dark
                  @click="$emit('getData', filter)"
                >
                  <span>جست و جو</span>
                  <v-icon small class="mx-1"> mdi-magnify </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </Transition>
      </template>
    </BaseCard>
  </template>
  <script>
  import { RepoFactory } from "@/baseRepository/Factory";
  const contentTypesRepository = () => RepoFactory.get("contentTypes");
  import Helper from "@/core/helpers";
  import { mapGetters } from "vuex";
  const cfaqRepository = () => RepoFactory.get("categorizingFaqPage");
  import qs from 'qs'
  export default {

    props: {
      resetFilter:{
        type: Boolean,
        default: false,
      }
    },
    data() {
      return {
        showSetting: false,
        categoriesItems:[],
        filter: {
          question:null,
          faqCategoryId:null,
          
        },
      };
    },
    watch:{
     merchantId(aft){
      if(aft){
        this.getcategoriesItems()
      }
     },
      resetFilter(){
        this.showSetting= false,
        this.filter= {
          question:null,
          faqCategoryId:null,
        }
        this.$emit('resetFilter')
      },
    },
    computed: {
      baseUrl() {
        return this.$store.getters.contentBaseUrl;
      },
      merchantId(){
        return this.$store.getters.currentMerchant;
      }
     
    },

    mounted() {
      if(this.merchantId) this.getcategoriesItems()
    },
    methods: {
      getcategoriesItems() {
      this.categoriesItems = [];
      const loader =this.$loading.show();
      cfaqRepository()
        .getFaqcategories(this.baseUrl, {
          MerchantId : this.$store.getters.currentMerchant

        })
        .then(res => {
          this.categoriesItems = res.data.map(item => {
            return {
              text: item.title,
              value: item.id,
              disabled :item.disabled
            };
          });
          loader.hide()
        })
        .catch(error => {
          Helper.handleErrors(error, this);
          loader.hide()
        });
    },
      pruneParamsToSend(params) {
        for (const key in params) {
          const element = params[key];
          if (Array.isArray(element)) {
            if (element.length) {
              params[key] = element;
            } else {
              delete params[key];
            }
          } else {
            if (element != "" && element != null) {
              params[key] = element;
            } else {
              delete params[key];
            }
          }
        }
    },
    },
  };
  </script>
  <style scoped>
  .slide-up-enter-active {
    transition: all 0.25s ease-out;
  }
  .slide-up-leave-active {
    transition: all 0.08s ease-out;
  }
  
  .slide-up-enter-from {
    opacity: 0;
    transform: translateY(30px);
  }
  
  .slide-up-leave-to {
    opacity: 0;
    transform: translateY(-20px);
  }
  </style>
  